/**
 * Single Rollbar instance shared by the React Provider and non-React call sites
 * (e.g. axios interceptors). Importing the instance avoids double-initialisation,
 * which would duplicate every uncaught-error and unhandled-rejection report.
 */

import Rollbar from "rollbar";

const accessToken = import.meta.env.REACT_APP_ROLLBAR_ACCESS_TOKEN;

export const rollbarConfig = {
  accessToken,
  environment: import.meta.env.REACT_APP_ROLLBAR_ENV,
  enabled: !!accessToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  codeVersion: import.meta.env.REACT_APP_VERSION,
  reportLevel: "error",
  captureIp: "anonymize",
  scrubTelemetryInputs: true,
  scrubFields: [
    "password",
    "token",
    "secret",
    "authorization",
    "cookie",
    "csrf_token",
    "email",
    "phone",
    "phone_number",
    "phoneNumber",
    "address",
    "postcode",
    "postal_code",
    "card",
    "cardNumber",
    "cvv",
    "authToken",
  ],
  ignoredMessages: [
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications.",
    "Script error.",
  ],
  checkIgnore: (isUncaught, args, payload) => {
    for (const arg of args) {
      if (!arg || typeof arg !== "object") continue;
      const isAxios = arg.isAxiosError === true || arg.name === "AxiosError";
      const status = arg.response?.status ?? arg.status;
      if (isAxios && (status === 400 || status === 422)) return true;
    }
    const trace = payload?.body?.trace || payload?.body?.trace_chain?.[0];
    const cls = trace?.exception?.class;
    const msg = trace?.exception?.message || "";
    if (cls === "AxiosError" && /status code (400|422)\b/.test(msg)) return true;
    return false;
  },
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
};

export const rollbarInstance = accessToken ? new Rollbar(rollbarConfig) : null;
